import {combineReducers} from "redux";
import DashboardReducer from "../../packages/Dashboard/store/DashboardReducer"
export default combineReducers({

    DashboardReducer,
   
})
